import React from 'react'
import '../Contact/Contact.css';
import { BsEnvelopeFill, BsGeoAltFill, BsTelephoneFill } from 'react-icons/bs';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function Contact() {
  return (
    <>
      <section className="about-section1 d-flex align-items-center">
        <div className="container text-center text-white">
          <h1 className="fw-bold">Contact Us</h1>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card shadow-sm text-center p-4 h-100">
                <div className="icon-box mb-3">
                  <BsTelephoneFill class="bi bi-telephone-fill" />
                </div>
                <h5 className="fw-bold">Phone</h5>
                <p className="mb-0">+91 988 010 4505</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm text-center p-4 h-100">
                <div className="icon-box mb-3">
                  <BsEnvelopeFill class="bi bi-envelope-fill" />
                </div>
                <h5 class="fw-bold">Email</h5>
                <p class="mb-0">rajucaterer1@gmail.com</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm text-center p-4 h-100">
                <div className="icon-box mb-3">
                  <BsGeoAltFill class="bi bi-geo-alt-fill" />
                </div>
                <h5 className="fw-bold">Head Office</h5>
                <p className="mb-0">#12, 1st cross, St. James Church Road, Maria Street, Mariyannapalya, Kempapura, Hebbal, Bengaluru - 560024</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <div className="container py-5">
        <h3 className="mb-4">Get A Quote</h3>
        <form>
          <div className="row g-3">

            <div className="col-md-6">
              <div className="input-group">
                <input type="text" class="form-control" placeholder="Enter your name" />
                <span className="input-group-text"><i className="bi bi-person-fill custom-pencil"></i></span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="input-group">
                <input type="email" class="form-control" placeholder="Enter email address" />
                <span className="input-group-text"><i className="bi bi-envelope-fill custom-pencil"></i></span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="input-group">
                <input type="text" className="form-control" placeholder="Enter the subject" />
                <span className="input-group-text"><i className="bi bi-eye custom-pencil"></i></span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="input-group">
                <input type="tel" class="form-control" placeholder="Enter phone number" />
                <span className="input-group-text"><i className="bi bi-telephone-fill custom-pencil"></i></span>
              </div>
            </div>

            <div className="col-12">
              <div className="input-group">
                <textarea className="form-control" rows="5" placeholder="Enter message"></textarea>
                <span className="input-group-text"><i className="bi bi-pencil-fill custom-pencil"></i></span>
              </div>
            </div>

            <div className="col-12">
              <button type="submit" className="btn btn-info px-4 text-white" style={{ backgroundColor: '#cf6511' }}>SUBMIT NOW</button>
            </div>
          </div>
        </form>
      </div>

      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-12 col-md-12">
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.7884571645664!2d77.61254351482283!3d13.049133090805064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae177a39249ae5%3A0x2b3be674813f7685!2sRaju%20Caterers!5e0!3m2!1sen!2sin!4v1661755234387!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact
